<template>
  <div>
    <div style="position: relative; width: 100%; display: inline-block;">

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           width="878"
           height="130" viewBox="0 0 878 130">
        <defs>
          <path id="prefix__a" d="M0.213 0.34L6.949 0.34 6.949 227.893 0.213 227.893z"/>
          <path id="prefix__c" d="M0 254L215.002 254 215.002 0.511 0 0.511z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">

          <slot name="g"/>

        </g>
      </svg>

      <slot/>
    </div>
  </div>
</template>

<script>

    export default {
        components: {},
        data() {
            return {}
        },
        props: {
            animateIndex: {
                type: Number,
                default: -1
            }
        }
    }
</script>

<style scoped>

</style>
